import { useCanAccess, useGetList } from "ra-core";

/**
 * Almikia Epic PL (TASK-062): number of `nuevo` pilot reports for the Settings
 * entry badge. One head-sized request (perPage 1, only the `total` is used),
 * and none at all for roles that cannot read reports. Returns 0 while loading.
 */
export const usePilotReportsNewCount = () => {
  const { canAccess } = useCanAccess({
    resource: "feedback_reports_summary",
    action: "list",
  });
  const { total } = useGetList(
    "feedback_reports_summary",
    {
      pagination: { page: 1, perPage: 1 },
      filter: { status: "nuevo" },
    },
    { enabled: canAccess === true },
  );
  return canAccess ? (total ?? 0) : 0;
};
